<script>
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import apigeneric from "@/helpers/apigeneric";
  import Loader from "@/components/widgets/loader";
  import Banner from "../components/banner";
  import apibtoast from "@/helpers/apibtoast";
  
  export default {
    page: {
      title: "Web Siteleri",
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    },
    components: {
      Layout,
      Loader,
      Banner
  
    },
    mixins: [apigeneric, apibtoast],
    data() {
      return {
        TableData: {},
        DefaultPage: 1,
        Page: {
          PageNumber: "1",
          PageSize: "10",
          PageDataSize: "1",
        },
        
        KomisyonId: this.$route.params.KomisyonId,

        
      };
    },
    methods: {
      Get() {

        this.ActionsFilterGet({ Service: "komisyonpersoneller", Page: this.Page, Filter: "&Komisyonid=" + this.KomisyonId }).then((res) => {
            this.TableData = res.Data;

   });
        }
    },
  };
  </script>
      
  <template>
    <Loader>
      <Layout>
        <Banner />
        <div class="title c-flex flex-column mt-3 col-md-8 mx-auto" style="background-color: #0071c5; height: 50px; padding: 10px; box-shadow: 5px 7px 5px #888888; border-radius: 10px;">
          <p class="h2 text-center" style="color: white">{{ $t("komisyonlar.komisyonpersoneller.Title") }}</p>
          </div>
          <div class="row mt-5 mb-3">
                     <div class="card col-md-2 mx-3 bg-gradient text-light text-center mx-auto" v-for="(Data,index) in TableData" :key="index" style="background-color:#2774AE; box-shadow: 5px 5px 5px #888888;">
                          <div>
                         <img v-if="Data.Resimurl" class="card-img-top mt-2" :src="Data.Resimurl" alt="Personel image" style="width:100%; border-radius:10px">
                         <img v-if="Data.Resimurl==null" class="card-img-top mt-2" src="@/assets/images/personelicon.png" alt="Personel image" style="width:100%; border-radius:10px">
                       </div>
                         <div class="card-body">
                            <h4 class="card-title text-light xs">{{ Data.Adsoyad }}</h4>
                            <p class="card-text xs">{{Data.Unvan}}</p>
                            <p class="card-text">{{Data.Mail}}</p>
                         </div>
                      </div>
                </div>
            

   

      </Layout>
    </Loader>
  </template>
      